"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import { getCustomerNameDisplay } from "../customerNameDisplay";
function loadShipmentText(loadShipment) {
  const customerName = loadShipment.customer_name ? getCustomerNameDisplay(
    loadShipment.customer_name,
    loadShipment.customer_external_id
  ) : "(Missing Customer)";
  if (loadShipment.state === "Approved") {
    return `${customerName} - Approved`;
  } else if (loadShipment.approvable) {
    return `${customerName} - Ready to Bill`;
  } else {
    return `${customerName} - Billing exceptions`;
  }
}
function submitResolveExceptions(props, e) {
  e.preventDefault();
  props.confirmMessageOrException();
}
function AuditBillingConfirmationButtons(props) {
  if (props.isApprovable) {
    return /* @__PURE__ */ jsx(
      "div",
      {
        "data-component": "AuditBillingConfirmationButtons",
        className: "audit-billing-confirmation__approve-section",
        children: /* @__PURE__ */ jsx("button", { className: "button--progress", onClick: props.approve, children: "Save and Approve" })
      }
    );
  } else {
    return /* @__PURE__ */ jsx("form", { onSubmit: (e) => submitResolveExceptions(props, e), children: /* @__PURE__ */ jsxs("div", { className: "audit-billing-confirmation__buttons", children: [
      /* @__PURE__ */ jsxs("fieldset", { children: [
        /* @__PURE__ */ jsx("h6", { children: "Resolve Exceptions by:" }),
        /* @__PURE__ */ jsxs("div", { className: "audit-billing-confirmation__radio-button", children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              type: "radio",
              id: "sendMessage",
              name: "MessageOrException",
              checked: props.messageOrException === "sendMessage",
              onChange: props.handleMessageOrException,
              value: "sendMessage"
            }
          ),
          /* @__PURE__ */ jsx("label", { htmlFor: "sendMessage", children: "Send Message" })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "audit-billing-confirmation__radio-button", children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              type: "radio",
              id: "saveException",
              name: "MessageOrException",
              checked: props.messageOrException === "saveException",
              onChange: props.handleMessageOrException,
              value: "saveException"
            }
          ),
          /* @__PURE__ */ jsx("label", { htmlFor: "saveException", children: "Save Exception" }),
          /* @__PURE__ */ jsx("br", {})
        ] })
      ] }),
      /* @__PURE__ */ jsx("button", { onClick: (e) => submitResolveExceptions(props, e), children: "Confirm" })
    ] }) });
  }
}
function allApprovable(props) {
  const loadShipments = props.load.load.tms_load_shipments;
  const approvableloadShipments = loadShipments.every(
    (loadShipment) => !!loadShipment.approvable
  );
  return props.carrierInvoice.approvable && approvableloadShipments;
}
function paymentText(props) {
  if (props.carrierInvoice.state === "partial_approved") {
    return `${props.carrier.name} - Approved`;
  } else if (props.carrierInvoice.approvable) {
    return `${props.carrier.name} - Ready to Pay`;
  } else {
    return `${props.carrier.name} - Payment exceptions`;
  }
}
function statusTexts(props) {
  const loadShipmentTexts = props.load.load.tms_load_shipments.map(loadShipmentText).join(", ");
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsxs("span", { className: "audit-billing-confirmation__status", children: [
      loadShipmentTexts,
      ",",
      " "
    ] }),
    /* @__PURE__ */ jsx("span", { className: "audit-billing-confirmation__status", children: paymentText(props) })
  ] });
}
function AuditBillingConfirmation(props) {
  const confirmMessageOrException = () => {
    if (props.messageOrException === "sendMessage") {
      props.handleSendMessage();
    } else if (props.messageOrException === "saveException") {
      props.handleSaveException();
    }
  };
  const approve = () => {
    props.handleApprove(props.payment, true);
  };
  return /* @__PURE__ */ jsxs("div", { className: " audit-billing-confirmation", children: [
    /* @__PURE__ */ jsx("div", { className: "audit-billing-confirmation__status_header", children: "Status:" }),
    statusTexts(props),
    /* @__PURE__ */ jsx(
      AuditBillingConfirmationButtons,
      {
        isApprovable: allApprovable(props),
        messageOrException: props.messageOrException,
        handleMessageOrException: props.handleMessageOrException,
        confirmMessageOrException,
        approve
      }
    )
  ] });
}
export default AuditBillingConfirmation;
